/**
 *
 * This page container contains the main tag and transition logic. It should
 * wrap all pages in their respective template files. If used in DefaultLayout,
 * it cannot access Transition State.
 *
 */

import React, { useRef } from "react";
import { useAppState } from "@state";
import useLgcaAcFooterData from "@staticQueries/lgcaAc/FooterQuery";
import classNames from "classnames";
import filterActions from "@utils/filterActions";
import loadable from "@loadable/component";
import { m } from "framer-motion";

const LgcaAcFooter = loadable(() => import("@organisms/LgcaAcFooter"));
const Cta = loadable(() => import("@organisms/Cta"));

const PageContainer = ({ children, className, path }) => {
  const [{ layout, ea }] = useAppState();
  const { footerNav, actions } = useLgcaAcFooterData();

  const upNext = filterActions(actions, ea.activistCodes || []);

  const action = upNext.length >= 1 ? upNext[0] : actions[actions.length - 1];
  const { theme, template } = layout;
  const isAction = template === "action";

  const page = useRef();

  const entered = true;

  return (
    <m.div
      ref={page}
      id="ac-layout"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className={`
      ${theme === "dark" ? "bg-brown" : "bg-cream"}
      ${!entered ? "opacity-0" : ""}
      flex w-full flex-col`}
    >
      <main className={classNames("flex flex-col", className)}>{children}</main>
      <footer>
        {!isAction && action && (
          <div>
            <Cta
              heading={action.heading}
              copy={action.copy}
              icon="buffalo"
              backgroundImage={action.backgroundImage}
              action={action}
              showAction
              path={path}
            />
          </div>
        )}
        <LgcaAcFooter nav={footerNav} />
      </footer>
    </m.div>
  );
};

PageContainer.defaultProps = {
  className: "",
};

export default PageContainer;
